export var SessionResponseClassEnum;
(function (SessionResponseClassEnum) {
    SessionResponseClassEnum["SessionResponse"] = "SessionResponse";
    SessionResponseClassEnum["StructuredMessage"] = "StructuredMessage";
    SessionResponseClassEnum["JWTResponse"] = "JwtResponse";
    SessionResponseClassEnum["PresignedUrlResponse"] = "PresignedUrlResponse";
    SessionResponseClassEnum["UploadSuccessEvent"] = "UploadSuccessEvent";
    // errors
    SessionResponseClassEnum["StringResponse"] = "string";
    SessionResponseClassEnum["ErrorMessage"] = "ErrorMessage";
    SessionResponseClassEnum["GenerateUrlError"] = "GenerateUrlError";
    SessionResponseClassEnum["TooManyRequestsErrorMessage"] = "TooManyRequestsErrorMessage";
})(SessionResponseClassEnum || (SessionResponseClassEnum = {}));
/** event */
export class EventCustomerJoin {
    constructor() {
        this.eventType = "Presence";
        this.presence = { type: "Join" };
    }
}
export class EventCustomerDisconnect {
    constructor(readOnly) {
        this.eventType = "Presence";
        this.presence = { type: "Disconnect" };
        this.readOnly = readOnly;
    }
}
export class EventCustomer {
    constructor(type) {
        this.eventType = "Presence";
        this.presence = { type };
    }
}
export class EventCustomerClear {
    constructor() {
        this.eventType = "Presence";
        this.presence = { type: "Clear" };
    }
}
export class EventCustomerTyping {
    constructor(type, duration) {
        this.eventType = "Typing";
        this.typing = { type, duration };
    }
}
export class MessageCustomerJoin {
    constructor() {
        this.type = "Event";
        this.events = [new EventCustomerJoin()];
    }
}
export class MessageCustomerTyping {
    constructor(state) {
        this.type = "Event";
        this.events = [new EventCustomerTyping(state, undefined)];
    }
}
export class MessageClearConversation {
    constructor() {
        this.type = "Event";
        this.events = [new EventCustomerClear()];
    }
}
export class MessageText {
    constructor(text) {
        this.text = text;
        this.type = "Text";
    }
}
export class MessageStructured {
    constructor(text) {
        this.text = text;
        this.type = "Structured";
    }
}
export class MessageAttachment {
    constructor(text) {
        this.type = "Text";
        this.text = text;
    }
}
export class SessionRequestBuilder {
    constructor(token) {
        this.token = token;
        this.action = "onMessage";
        this.channel = { metadata: { customAttributes: {} } };
    }
    setMessage(value) {
        this.message = value;
        if (value instanceof MessageCustomerTyping ||
            value instanceof MessageStructured) {
            this.channel = undefined;
        }
        return this;
    }
    setContent(value) {
        this.content = value;
        return this;
    }
    setMetadata(value) {
        switch (this.message.type) {
            case "Structured":
                this.metadata = value;
                break;
            case "Text":
            case "Event":
                this.channel.metadata.customAttributes = value;
                this.metadata = value;
                break;
        }
        return this;
    }
    /**
     * 'channel' in root is deprecated. Use it inside 'message'
     * @returns a serializable message object
     */
    build() {
        return {
            action: this.action,
            token: this.token,
            message: Object.assign({ channel: this.channel, content: this.content, metadata: this.metadata }, this.message),
        };
    }
}
export class SessionResponseStructuredMessageBodyBot {
    constructor(body) {
        var _a;
        this.direction = body.direction;
        this.id = body.id;
        this.type = "Structured";
        this.channel = body.channel;
        this.metadata = Object.assign(Object.assign({}, body.metadata), (_a = body.channel.metadata) === null || _a === void 0 ? void 0 : _a.customAttributes);
        this.text = body.text;
        this.from = body.channel.from;
        this.originatingEntity = body.originatingEntity;
        this.content = body.content;
    }
}
export class SessionResponseStructuredMessageBodyText {
    constructor(body) {
        var _a;
        this.direction = body.direction;
        this.id = body.id;
        this.type = "Text";
        this.channel = body.channel;
        this.metadata = Object.assign(Object.assign({}, body.metadata), (_a = body.channel.metadata) === null || _a === void 0 ? void 0 : _a.customAttributes);
        this.text = body.text;
        this.content = body.content;
        this.originatingEntity = body.originatingEntity;
        this.from = body.channel.from;
        this.originatingEntity = body.originatingEntity;
    }
}
export class SessionResponseStructuredMessageBodyEvent {
    constructor(body) {
        var _a;
        this.direction = body.direction;
        this.id = body.id;
        this.type = "Event";
        this.channel = body.channel;
        this.metadata = body.metadata;
        this.events = (_a = body === null || body === void 0 ? void 0 : body.events) === null || _a === void 0 ? void 0 : _a.map((event) => {
            var _a, _b, _c, _d, _e;
            switch (event.eventType) {
                case "Presence":
                    switch ((_a = event.presence) === null || _a === void 0 ? void 0 : _a.type) {
                        case "Join":
                            return new EventCustomerJoin();
                        case "Disconnect":
                            return new EventCustomerDisconnect(((_b = body.metadata) === null || _b === void 0 ? void 0 : _b.readOnly) === "true");
                        case "Clear":
                            return new EventCustomerClear();
                        default:
                            return new EventCustomer((_c = event.presence) === null || _c === void 0 ? void 0 : _c.type);
                    }
                case "Typing":
                    return new EventCustomerTyping((_d = event.typing) === null || _d === void 0 ? void 0 : _d.type, (_e = event.typing) === null || _e === void 0 ? void 0 : _e.duration);
                default:
                    return null;
            }
        });
    }
    getEvent() {
        var _a;
        return (_a = this.events) === null || _a === void 0 ? void 0 : _a[0];
    }
    getEventType() {
        var _a;
        return (_a = this.getEvent()) === null || _a === void 0 ? void 0 : _a.eventType;
    }
    getPresenceType() {
        var _a, _b;
        return (_b = (_a = this.getEvent()) === null || _a === void 0 ? void 0 : _a.presence) === null || _b === void 0 ? void 0 : _b.type;
    }
}
export class SessionResponseStructuredMessage {
    constructor(message) {
        this.class = message.class;
        this.type = message.type;
        this.code = message.code;
        switch (message.body.type) {
            case "Event":
                this.body = new SessionResponseStructuredMessageBodyEvent(message.body);
                break;
            case "Text":
                this.body = new SessionResponseStructuredMessageBodyText(message.body);
                break;
            case "Structured":
                this.body = new SessionResponseStructuredMessageBodyBot(message.body);
                break;
        }
    }
    getMetadata() {
        var _a;
        return (_a = this.body) === null || _a === void 0 ? void 0 : _a.metadata;
    }
    getContent() {
        return (this.body.content || []);
    }
}
//# sourceMappingURL=webMessenger.js.map